var Pagination = /** @class */ (function () {
    function Pagination(pageNumber, limit, totalResults) {
        if (pageNumber === void 0) { pageNumber = 0; }
        if (limit === void 0) { limit = 10; }
        this.pageNumber = 0;
        this.limit = 10;
        this.totalResults = 0;
        this.pageNumber = pageNumber;
        this.limit = limit;
        if (totalResults)
            this.setTotalResults(totalResults);
    }
    Pagination.prototype.setTotalResults = function (total) {
        this.totalResults = total;
        this._setTotalPages();
    };
    Pagination.prototype._setTotalPages = function () {
        this.totalPages = Math.ceil(this.totalResults / this.limit);
    };
    Object.defineProperty(Pagination.prototype, "offset", {
        // private _offset: number;
        get: function () {
            return this.pageNumber * this.limit;
        },
        enumerable: true,
        configurable: true
    });
    ;
    Object.defineProperty(Pagination.prototype, "currentNumberShown", {
        /**
         * Displays the total number of results currently being show
         */
        get: function () {
            return this.pageNumber + 1 < this.totalPages ? (this.pageNumber + 1) * this.limit : this.totalResults;
        },
        enumerable: true,
        configurable: true
    });
    return Pagination;
}());
export { Pagination };
